<template>

    <el-dialog :title="'添加推荐商品'"  :visible.sync="addFormVisible" width="60%" left
               :close-on-click-modal="false">
        <el-form :label-width="formLabelWidth">
            <div>
                <el-row :span="24">
                    <el-col :sm="5" :md="5" :lg="5">
                        <el-form-item label="所属分类" label-width="80px" prop="pid">
                            <el-cascader v-model="searchForm.subjectIds" :show-all-levels="false" ref="tree" collapse-tags :options="subjectTreeList" :props="subjectTreeProps" clearable></el-cascader>
                        </el-form-item>
                    </el-col>

                    <el-col :sm="5" :md="5" :lg="5">
                        <el-form-item label="是否限购" label-width="80px" prop="flashSaleType">
                            <el-select v-model="searchForm.flashSaleType" placeholder="请选择" clearable>
                                <el-option value="">全部</el-option>
                                <el-option :label="'是'" :value="'1'"></el-option>
                                <el-option :label="'否'" :value="'-1'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="8" :md="8" :lg="8">
                        <el-form-item label="商品名称">
                            <el-input v-model="searchForm.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
                        <el-button type="primary" @click="getList()">查询</el-button>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-col :sm="24" :md="24" :lg="24">
                        <el-table :data="tableList" tooltip-effect="dark" style="width: 100%"
                                  @selection-change="handleSelectionChange"
                                  ref="multipleTable"
                                  :row-key="getRowKey"
                                  highlight-current-row  border v-loading="loading1"
                                  element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)">
                            <el-table-column
                                    type="selection"
                                    :reserve-selection="true"
                                    width="55">
                            </el-table-column>

                            <el-table-column prop="name" show-overflow-tooltip label="商品">
                                <template slot-scope="row">
                                    <el-row>
                                        <el-col :span="8">
                        <span>
                          <img style="margin-right: 10px" width="100%" height="44px" :src="
                              row.row.logo
                                ? row.row.logo
                                : '../../../static/image/noImg.png'
                            " />
                        </span>
                                        </el-col>
                                        <el-col :span="16">
                        <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                          row.row.name
                        }}</span>
                                            <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            ">￥{{ row.row.originalPrice }}</span>
                        </span>
                                        </el-col>
                                    </el-row>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                                <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span style="text-decoration: line-through; color: rgb(162, 170, 188)">￥{{ row.row.originalPrice }}</span>
                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                                <template slot-scope="row">{{
                                    row.row.validDay ? row.row.validDay + "天" : "不限"
                                    }}</template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="200" prop="subjectCourseName" label="所属科目"></el-table-column>
                        </el-table>
                        <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
                    </el-col>
                </el-row>
            </div>



        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="cancelDialog">取 消</el-button>
            <el-button type="primary" @click="closeDialog">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "choose-goods-dialog",

        props:['addFormVisible','choosedData'],

        data(){
            return {
                subjectTreeProps: {
                    value: "id",
                    label: "name",
                    children: "children"
                },
                subjectTreeList: [], //科目
                searchForm: {
                    sell: 1,
                    name: "",
                    subjectIds: [],
                },
                formLabelWidth: "80px",
                tableList: [],
                loading1: false,
                checkList: [],
                page: {
                    total: 0,
                    pageSize: 10,
                    pageNumber: 1,
                    sortName: "",
                    sortOrder: "",
                },
            }
        },

        created:function () {
            this.getList();
            this.getSubjectTreeList()
            this.toggleSelection(this.choosedData)
        },
        computed: {
            ...mapGetters(["loginData"]),

        },

        methods:{
            toggleSelection (rows) {
                let that=this;

                this.$nextTick( ()=> {
                    rows.forEach(row => {
                        that.$refs.multipleTable.toggleRowSelection(row, true)
                    })

                })


            },
            getSubjectTreeList () {
                // 获取课程
                this.api
                        .getSubjectTreeList()
                        .then(result => {
                            for (let item of result.data) {
                                if (item.children.length != 0) {
                                    for (let items of item.children) {
                                        delete items.children

                                    }
                                }
                            }
                            this.subjectTreeList = result.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
            },
            getList () {
                this.loading1 = true;
                let arr = [];
                if (this.searchForm.subjectIds.length > 0) {
                    this.searchForm.subjectIds.forEach((item) => {
                        arr.push(item.reverse()[0]);
                    });
                }
                let obj = {
                    pageSize: this.page.pageSize,
                    pageNumber: this.page.pageNumber,
                    sortName: this.page.sortName,
                    sortOrder: this.page.sortOrder,
                    agentId: this.loginData.agentId,
                    flashSaleType: this.searchForm.flashSaleType,
                    name: this.searchForm.name,
                    subjectIds: arr,
                };


                this.api.goodsInfo['pageList'](obj)
                        .then((result) => {
                            this.loading1 = false;
                            this.tableList = result.data.records;
                            this.page.total = result.data.total;
                            this.arrsSelect = [];
                        })

                        .catch((error) => {
                            console.log(error);
                        });
            },
            currentChange (pageNumber) {
                this.page.pageNumber = pageNumber;
                this.getList();
            },
            sizeChange (pageSize) {
                this.page.pageSize = pageSize;
                this.getList();
            },
            unique(arr) {
                const res = new Map();
                return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
            },
            handleSelectionChange(val){
                this.checkList = this.unique(val);

            },
            getRowKey(row) {
                return row.id;
            },

            closeDialog () {
                this.$emit('func',this.checkList,false);
            },
            cancelDialog(){
                this.$emit('cancel',false);

            }
        },

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/goods/chooseGoodsDialog.vue